import { render, staticRenderFns } from "./top-lock.vue?vue&type=template&id=d7972848&scoped=true"
import script from "./top-lock.vue?vue&type=script&lang=js"
export * from "./top-lock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7972848",
  null
  
)

export default component.exports